import ColorfulTabs from './colorful-tabs';
export default ColorfulTabs;
